import Enum from './Domain'

class TypeField extends Enum { }

TypeField.initEnum(['INPUT', 'TEXTAREA'])

export default TypeField
